import { IconInfoCircle } from '@tabler/icons-react';
import { ReleaseNoteSectionViewOf } from 'bff';
import { ReactNode } from 'react';
import { cn } from 'ui';
import { editorialSerif } from '../editorial';
import { RichText } from '../RichText';

export const ReleaseNoteCallout = ({ children }: { children: ReactNode }) => (
  <div className='flex gap-3 rounded-xl bg-stone-100 p-4 text-sm text-stone-700'>
    <IconInfoCircle className='mt-0.5 h-4 w-4 shrink-0 text-primary' />
    <div className='flex flex-col gap-2'>{children}</div>
  </div>
);

// In the article a callout is the line to remember, set as a pull quote.
export const CalloutSection = ({
  section: { content },
}: {
  section: ReleaseNoteSectionViewOf<'callout'>;
}) => (
  <blockquote
    className={cn(
      editorialSerif,
      'my-11 flex flex-col gap-3 border-y border-foreground py-5 text-[1.375rem] font-medium leading-[1.28] text-foreground md:text-[1.875rem]',
    )}
  >
    <RichText text={content.body} className='leading-[1.28]' />
  </blockquote>
);
